import React, { useState } from "react"
import { Autocomplete, TextField } from "@mui/material"

export function ReportClientSelector({ data, setClient }) {
    const [selectedClient, setSelectedClient] = useState(null)

    const sortedClients = data.filter((row) => row.clientName).sort((a, b) => a.clientName.localeCompare(b.clientName))

    const handleChange = (event, newValue) => {
        setSelectedClient(newValue)
        setClient(newValue || {})
    }

    return (
        <Autocomplete
            options={sortedClients}
            getOptionLabel={(option) => `${option.clientName} (${option.client})`}
            value={selectedClient}
            onChange={handleChange}
            renderInput={(params) => <TextField {...params} label="Select Client" variant="standard" fullWidth />}
        />
    )
}
